module.exports = __webpack_public_path__ + "img/milk.aff3a68e.svg";